import { Settings } from "@mui/icons-material";
import React, { useState } from "react";
// import { useHistory } from "react-router-dom"; // To navigate after success
import Cookies from "js-cookie";
import { ApiUrl } from "../config";

const Parametres = () => {
  const token = Cookies.get("access_token");
  // State to store form data and error messages
  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  });

  const [errors, setErrors] = useState({
    currentPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  });

  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const [isSubmitting, setIsSubmitting] = useState(false);

  // Handle form data change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const validateForm = () => {
    setSuccessMessage("");
    setErrorMessage("");
    const newErrors = { ...errors };

    // Validate current password
    if (!formData.currentPassword) {
      newErrors.currentPassword = "*";
      return "Le mot de passe actuel est requis";
    }

    // Validate new password
    if (!formData.newPassword) {
      newErrors.newPassword = "*";
      return "Le nouveau mot de passe est requis"; // Add to the error list
    }

    // Check if new password meets length requirement (minimum 8 characters)
    if (formData.newPassword && formData.newPassword.length < 8) {
      newErrors.newPassword = "*";
      return "Le nouveau mot de passe doit comporter au moins 8 caractères - plus c'est mieux"; // Add to the error list
    }

    // Check if new and confirm new password match
    if (formData.newPassword !== formData.confirmNewPassword) {
      newErrors.confirmNewPassword = "Les mots de passe ne correspondent pas";
      return newErrors.confirmNewPassword;
    }

    // // Update errors state and return if form is valid
    setErrors(newErrors);
  };

  // Handle form submission using fetch
  const handleSubmit = async (e) => {
    e.preventDefault();

    const ValidateFormSuccess = validateForm();

    if (ValidateFormSuccess) {
      setErrorMessage(ValidateFormSuccess);
      return;
    }

    setIsSubmitting(true);
    setErrorMessage("");
    setSuccessMessage("");

    const requestBody = {
      current_password: formData.currentPassword,
      new_password: formData.newPassword,
      new_password_confirmation: formData.confirmNewPassword,
    };

    try {
      const response = await fetch(
        `${ApiUrl}change-pass-citoyen`,
       // "https://backend03.hnam3ak.ma/api/change-pass-citoyen",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(requestBody),
        }
      );

      const data = await response.json();

      if (response.ok) {
        setSuccessMessage(data.message);
        setTimeout(() => setSuccessMessage(""), 3000);
        setFormData({
          currentPassword: "",
          newPassword: "",
          confirmNewPassword: "",
        });
        setErrors({
          currentPassword: "",
          newPassword: "",
          confirmNewPassword: "",
        });

        setIsSubmitting(false);
      } else {
        setIsSubmitting(false);
        setErrorMessage(data.error || "Something went wrong");
      }
    } catch (error) {
      setIsSubmitting(false);
      setErrorMessage("Network error. Please try again later.");
      console.log(error);
    }
  };

  return (
    <div>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb breadcrumb-no-gutter">
          <li class="breadcrumb-item">
            <a class="breadcrumb-link" href="javascript:;">
              Page d'acceuil
            </a>
          </li>
          <li
            class="breadcrumb-item active"
            style={{ color: "rgb(255, 77, 7)" }}
            aria-current="page"
          >
            Paramètres
          </li>
        </ol>
      </nav>

      <div className="row justify-content-lg-center">
        <div className="col-lg-7">
          <div className="card px-4 py-2">
            <div className="card-header">
              <h4 className="card-title">Modifier votre mot de passe</h4>
            </div>
            <div className="card-body">
              <form className="container" onSubmit={handleSubmit}>
                {/* Display error or success message */}
                {errorMessage && (
                  <div className="mt-2">
                    <div className="alert alert-danger">{errorMessage}</div>
                  </div>
                )}
                {successMessage && (
                  <div className="mt-2">
                    <div className="alert alert-success">{successMessage}</div>
                  </div>
                )}
                <div className="row mb-4">
                  <label
                    htmlFor="currentPassword"
                    className="col-sm-3 col-form-label form-label"
                  >
                    Mot de passe actuel
                  </label>

                  <div className="col-sm-9">
                    <input
                      type="password"
                      className="profile-form-control"
                      name="currentPassword"
                      id="currentPassword"
                      placeholder="Saisissez votre mot de passe actuel"
                      value={formData.currentPassword}
                      onChange={handleChange}
                      aria-label="Saisissez votre mot de passe actuel"
                    />
                    {errors.currentPassword && (
                      <div className="text-danger">
                        {errors.currentPassword}
                      </div>
                    )}
                  </div>
                </div>

                <div className="row mb-4">
                  <label
                    htmlFor="newPassword"
                    className="col-sm-3 col-form-label form-label"
                  >
                    Nouveau mot de passe
                  </label>

                  <div className="col-sm-9">
                    <input
                      type="password"
                      className="profile-form-control"
                      name="newPassword"
                      id="newPassword"
                      placeholder="Saisissez un nouveau mot de passe"
                      value={formData.newPassword}
                      onChange={handleChange}
                      aria-label="Saisissez un nouveau mot de passe"
                    />
                    {errors.newPassword && (
                      <div className="text-danger">{errors.newPassword}</div>
                    )}
                  </div>
                </div>

                <div className="row mb-4">
                  <label
                    htmlFor="confirmNewPassword"
                    className="col-sm-3 col-form-label form-label"
                  >
                    Confirmer le mot de passe
                  </label>

                  <div className="col-sm-9">
                    <div className="mb-3">
                      <input
                        type="password"
                        className="profile-form-control"
                        name="confirmNewPassword"
                        id="confirmNewPassword"
                        placeholder="Confirmez votre nouveau  mot de passe"
                        value={formData.confirmNewPassword}
                        onChange={handleChange}
                        aria-label="Confirmez votre nouveau mot de passe"
                      />
                      {errors.confirmNewPassword && (
                        <div className="text-danger">
                          {errors.confirmNewPassword}
                        </div>
                      )}
                    </div>

                    <h5>Exigences pour le mot de passe:</h5>

                    <p className="fs-6 mb-2">
                      Assurez-vous que ces critères sont respectés :
                    </p>

                    <ul className="fs-6">
                      <li>
                        Au moins 8 caractères - plus il est long, mieux c'est.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="d-flex justify-content-end">
                  <button
                    type="submit"
                    className="btn btn-base"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Enregistrement..." : "Enregistrer le modifications"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Parametres;
